module.exports = __webpack_public_path__ + "static/media/back-purple.9baa86b6.svg";